import 'bootstrap/js/src/collapse';
import 'bootstrap/js/src/modal';

// Use mainObj. instead of document. (because of Shadow DOM)
const mainObj = document.querySelector('main .htmlTemplate');

/**
 * DOMContentLoaded
 */
document.addEventListener('DOMContentLoaded', function () {
    // Show/hide product indicators
    let indicators = mainObj.querySelector('#indicators');
    let mobileIndicators = mainObj.querySelectorAll('.js-indicator-mobile');

    // Hide indicators - globally
    let hideIndicatorsSections = mainObj.querySelectorAll('.js-hide-indicators');
    hideIndicatorsSections.forEach(function (hideIndicatorsSection) {
        const observer = new IntersectionObserver(
            function (entries) {
                if (entries[0].isIntersecting) {
                    // indicators
                    indicators.classList.add('hidden-globally');
                    // mobile indicators
                    mobileIndicators.forEach(function (mobileIndicator) {
                        mobileIndicator.classList.add('hidden-globally');
                    });
                } else {
                    // indicators
                    indicators.classList.remove('hidden-globally');
                    // mobile indicators
                    mobileIndicators.forEach(function (mobileIndicator) {
                        mobileIndicator.classList.remove('hidden-globally');
                    });
                }
            },
            { threshold: [0], rootMargin: '-50% 0px -50% 0px' }
        );
        observer.observe(hideIndicatorsSection);
    });
    // Hide indicators - inside product sections (these are shown when scrolling up)
    let hideIndicatorsSectionsInProduct = mainObj.querySelectorAll('.js-hide-indicators-in-product');
    hideIndicatorsSectionsInProduct.forEach(function (hideIndicatorsSection) {
        const observer = new IntersectionObserver(
            function (entries) {
                if (entries[0].isIntersecting) {
                    // indicators
                    indicators.classList.add('hidden-in-product');
                    // mobile indicators
                    mobileIndicators.forEach(function (mobileIndicator) {
                        mobileIndicator.classList.add('hidden-in-product');
                    });
                } else {
                    // indicators
                    indicators.classList.remove('hidden-in-product');
                    // mobile indicators
                    mobileIndicators.forEach(function (mobileIndicator) {
                        mobileIndicator.classList.remove('hidden-in-product');
                    });
                }
            },
            { threshold: [0], rootMargin: '-50% 0px -50% 0px' }
        );
        observer.observe(hideIndicatorsSection);
    });

    // Show indicators when scrolling up
    let prevScrollPos = window.scrollY || window.pageYOffSet;
    window.addEventListener('scroll', function () {
        let currentScrollPos = window.scrollY || window.pageYOffSet;
        let isScrollingUp = prevScrollPos > currentScrollPos;
        // indicators
        indicators.classList.toggle('scroll-up', isScrollingUp);
        // mobile indicators
        mobileIndicators.forEach(function (mobileIndicator) {
            mobileIndicator.classList.toggle('scroll-up', isScrollingUp);
        });
        prevScrollPos = currentScrollPos;
    });

    // Product individual indicators - reveal additional info
    let phoneProducts = ['t-phone-2-pro', 't-phone-2', 't-tablet'];
    phoneProducts.forEach(function (phoneProduct) {
        let product = mainObj.querySelector('#' + phoneProduct);
        // observer
        if (product) {
            const observer = new IntersectionObserver(
                function (entries) {
                    let productIndicator = mainObj.querySelector('#' + phoneProduct + '-indicator');
                    let productIndicatorMobile = mainObj.querySelector('#' + phoneProduct + '-indicator-mobile');

                    // set initial value for animation start
                    let initialWidth = productIndicator.offsetWidth;
                    productIndicator.style.width = initialWidth + 'px';

                    if (entries[0].isIntersecting) {
                        // product indicator
                        productIndicator.classList.add('active');
                        productIndicator.setAttribute('role', 'none');
                        // product mobile indicator
                        productIndicatorMobile.classList.add('active');
                        // animation
                        let targetWidth = productIndicator.querySelector('.js-indicator-content').offsetWidth;
                        linearWidthAnimation(productIndicator, initialWidth, targetWidth);
                        productIndicator.classList.add('animating');
                        setTimeout(function () {
                            productIndicator.classList.remove('animating');
                        }, 500); // linearWidthAnimation duration
                    } else {
                        // product indicator
                        productIndicator.classList.remove('active');
                        productIndicator.setAttribute('role', 'button');
                        // product mobile indicator
                        productIndicatorMobile.classList.remove('active');
                        // animation
                        let targetWidth = productIndicator.getAttribute('data-initial-width');
                        linearWidthAnimation(productIndicator, initialWidth, targetWidth);
                        productIndicator.classList.add('animating');
                        setTimeout(function () {
                            productIndicator.classList.remove('animating');
                        }, 500); // linearWidthAnimation duration
                    }
                },
                { threshold: [0], rootMargin: '-50% 0px -50% 0px' }
            );
            observer.observe(product);
        }
    });

    // Counter
    let counter = mainObj.querySelector('.js-counter');
    if (counter) {
        const observer = new IntersectionObserver(
            function (entries) {
                if (entries[0].isIntersecting) {
                    if (counter.classList.contains('start-to-first-load')) {
                        setTimeout(function () {
                            const animate = () => {
                                const value = +100;
                                const data = +counter.innerText;
                                if (data < value) {
                                    counter.innerText = data + 1;
                                    setTimeout(animate, 12);
                                } else {
                                    counter.innerText = value;
                                }
                            };
                            animate();
                            counter.classList.remove('start-to-first-load');
                        }, 500);
                    }
                }
            },
            { threshold: [0], rootMargin: '-50px 0px -50px 0px' }
        );

        observer.observe(counter);
    }

    // Videos lazy-loading
    let lazyVideos = [].slice.call(mainObj.querySelectorAll('.js-load-video'));
    if ('IntersectionObserver' in window) {
        let lazyVideoObserver = new IntersectionObserver(
            function (entries) {
                entries.forEach(function (video) {
                    if (video.isIntersecting) {
                        let videoId = video.target.getAttribute('data-video-target');
                        if (videoId) {
                            mainObj
                                .querySelectorAll('.js-load-video[data-video-target="' + videoId + '"]')
                                .forEach(function (videoLauncher) {
                                    videoLauncher.setAttribute('data-video-target', '');
                                });

                            let videoTag = mainObj.querySelector('#' + videoId);
                            if (videoTag) {
                                for (let source in videoTag.children) {
                                    let videoSource = videoTag.children[source];
                                    if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
                                        videoSource.src = videoSource.dataset.src;
                                    }
                                }
                                videoTag.load();
                                lazyVideoObserver.unobserve(video.target);
                            }
                        }
                    }
                });
            },
            { threshold: [0], rootMargin: '0px 0px 0px 0px' }
        );

        lazyVideos.forEach(function (lazyVideo) {
            lazyVideoObserver.observe(lazyVideo);
        });
    }

    // Load more info button hover animation
    let loadMoreButtons = mainObj.querySelectorAll('.js-load-more-btn');
    if (loadMoreButtons) {
        loadMoreButtons.forEach(function (loadMoreButton) {
            loadMoreButton.addEventListener('mouseenter', () => {
                loadMoreButton.classList.remove('hide-info');
                loadMoreButton.classList.add('show-info');
            });
            loadMoreButton.addEventListener('mouseleave', () => {
                loadMoreButton.classList.add('hide-info');
            });
        });
    }

    // Close modal button hover animation
    let closeModalButtons = mainObj.querySelectorAll('.js-close-modal-btn');
    if (closeModalButtons) {
        closeModalButtons.forEach(function (closeModalButton) {
            closeModalButton.addEventListener('mouseenter', () => {
                closeModalButton.classList.remove('hide-info');
                closeModalButton.classList.add('show-info');
            });
            closeModalButton.addEventListener('mouseleave', () => {
                closeModalButton.classList.add('hide-info');
            });
        });
    }

    // Adjust button animation oh modal close
    let modals = mainObj.querySelectorAll('.js-modal');
    if (modals) {
        modals.forEach(function (modal) {
            modal.addEventListener('hidden.bs.modal', function () {
                modal.querySelector('.js-close-modal-btn').classList.remove('hide-info', 'show-info');
            });
        });
    }

    // Scroll to element/section
    let scrollToElements = mainObj.querySelectorAll('.js-scroll-to-element');
    if (scrollToElements) {
        scrollToElements.forEach(function (scrollToElement) {
            scrollToElement.addEventListener('click', function (e) {
                e.preventDefault();
                let target = scrollToElement.getAttribute('href');
                if (!target) {
                    target = scrollToElement.getAttribute('data-target');
                }
                if (target) {
                    scrollBodyToElement(target, mainObj);
                }
            });
        });
    }

    // Load animation
    let loadAnimationElements = mainObj.querySelectorAll('.load-animation, .load-animation-text, .load-animation-btn');
    if (loadAnimationElements) {
        loadAnimationElements.forEach(function (loadAnimationElement) {
            const observer = new IntersectionObserver(
                function (entries) {
                    if (entries[0].isIntersecting) {
                        loadAnimationElement.classList.add('loaded');
                    }
                },
                { threshold: [0], rootMargin: '0px 0px -10% 0px' }
            );
            observer.observe(loadAnimationElement);
        });
    }

    // Always refresh the page on top
    window.onbeforeunload = function () {
        window.scrollTo(0, 0);
    };
});

/**
 * Load
 */
window.addEventListener('load', function () {
    // Stabilization slider
    let stabilizationContainer = mainObj.querySelector('.js-stabilization');
    if (stabilizationContainer) {
        let slider = stabilizationContainer.querySelector('.js-stabilization-slider');
        let overlyVideoWrapper = stabilizationContainer.querySelector('.js-overlay-video-wrapper');
        let overlyVideo = overlyVideoWrapper.querySelector('.js-overlay-video');
        let sliderBtn = stabilizationContainer.querySelector('.js-stabilization-slider-btn');
        let sliderLine = stabilizationContainer.querySelector('.js-slider-line');
        let ois = stabilizationContainer.querySelector('.js-slider-ois');

        let sliderWidth = slider.offsetWidth;
        let sliderRect = slider.getBoundingClientRect();
        let resizeLastValueSlider;
        // update slider width/rect values when resize
        window.addEventListener(
            'resize',
            function () {
                let currentWidth = window.innerWidth;
                if (currentWidth !== resizeLastValueSlider) {
                    resizeLastValueSlider = currentWidth;
                    sliderWidth = slider.offsetWidth;
                    sliderRect = slider.getBoundingClientRect();
                }
            },
            true
        );
        // drag
        slider.addEventListener('input', (e) => {
            let sliderPos = e.target.value;
            overlyVideoWrapper.style.left = sliderPos + '%';
            sliderBtn.style.left = sliderPos + '%';
            sliderLine.style.left = sliderPos + '%';
            overlyVideo.style.transform = 'translateX(-' + sliderPos + '%)';
            ois.style.right = 'calc(' + sliderPos + '% + 6%)';
        });
        // mousemove
        slider.addEventListener('mousemove', function (e) {
            let positionInsideSlider = e.pageX - sliderRect.left;
            let positionPercentage = Math.abs(Math.round((positionInsideSlider * 100) / sliderWidth));
            if (positionPercentage < 5) {
                positionPercentage = 5;
            } else if (positionPercentage > 95) {
                positionPercentage = 95;
            }
            overlyVideoWrapper.style.left = positionPercentage + '%';
            sliderBtn.style.left = positionPercentage + '%';
            sliderLine.style.left = positionPercentage + '%';
            overlyVideo.style.transform = 'translateX(-' + positionPercentage + '%)';
            ois.style.right = 'calc(' + positionPercentage + '% + 6%)';
        });
        // mouse leave > slider back to 50 %
        stabilizationContainer.addEventListener('mouseleave', function () {
            overlyVideoWrapper.style.left = 50 + '%';
            sliderBtn.style.left = 50 + '%';
            sliderLine.style.left = 50 + '%';
            overlyVideo.style.transform = 'translateX(-' + 50 + '%)';
            ois.style.right = 'calc(' + 50 + '% + 6%)';
        });
    }

    // Products comparison
    let comparisonArrows = mainObj.querySelectorAll('.js-comparison-arrow');
    if (comparisonArrows) {
        // update product length dynamically based on resize
        let productLength = mainObj.querySelector('.js-comparison-row').offsetWidth;
        let resizeLastValue;
        window.addEventListener(
            'resize',
            function () {
                let currentWidth = window.innerWidth;
                if (currentWidth !== resizeLastValue && currentWidth < 992) {
                    resizeLastValue = currentWidth;
                    productLength = mainObj.querySelector('.js-comparison-row').offsetWidth;
                }
            },
            true
        );

        let scrollableContainer = mainObj.querySelector('.js-comparison-content');
        let leftArrow = mainObj.querySelector('.js-comparison-arrow[data-direction="left"]');
        let rightArrow = mainObj.querySelector('.js-comparison-arrow[data-direction="right"]');

        // T Phone 2 Pro as the default product for mobiles
        scrollableContainer.scrollLeft = productLength;

        // Tap - show/hide carousel arrows
        let isTouching = false;
        let lastTouchX = 0;
        scrollableContainer.addEventListener('touchstart', (event) => {
            isTouching = true;
            lastTouchX = event.touches[0].clientX;
        });
        scrollableContainer.addEventListener('touchmove', (event) => {
            if (isTouching) {
                const touchX = event.touches[0].clientX;
                const deltaX = touchX - lastTouchX;

                if (deltaX > 0) {
                    rightArrow.classList.remove('hidden');
                } else if (deltaX < 0) {
                    leftArrow.classList.remove('hidden');
                }

                lastTouchX = touchX;
            }
        });
        scrollableContainer.addEventListener('touchend', () => {
            isTouching = false;
        });

        // Horizontal scroll for mobiles
        comparisonArrows.forEach(function (comparisonArrow) {
            comparisonArrow.addEventListener('click', function (e) {
                e.preventDefault();
                let direction = comparisonArrow.getAttribute('data-direction');
                let currentPosition = scrollableContainer.scrollLeft;
                let targetPosition;

                if (direction === 'right') {
                    leftArrow.classList.remove('hidden');
                    if (currentPosition < productLength - 20) {
                        targetPosition = productLength;
                        rightArrow.classList.remove('hidden');
                    } else {
                        targetPosition = 2 * productLength;
                        rightArrow.classList.add('hidden');
                    }
                } else {
                    rightArrow.classList.remove('hidden');
                    if (currentPosition <= productLength + 20) {
                        targetPosition = 0;
                        leftArrow.classList.add('hidden');
                    } else {
                        targetPosition = productLength;
                        leftArrow.classList.remove('hidden');
                    }
                }

                scrollableContainer.scrollTo({
                    left: targetPosition,
                    behavior: 'smooth',
                });
            });
        });
    }
});

/**
 * Indicators animation
 *
 * @param element
 * @param currentWidth
 * @param target
 */
function linearWidthAnimation(element, currentWidth, target) {
    let startTime = performance.now();

    // animation 500s
    function animate(currentTime) {
        let elapsedTime = currentTime - startTime;
        let progress = Math.min(elapsedTime / 500, 1);
        let newWidth = currentWidth + (target - currentWidth) * progress;
        element.style.width = newWidth + 'px';

        if (progress < 1) {
            requestAnimationFrame(animate);
        } else {
            currentWidth = target;
        }
    }

    requestAnimationFrame(animate);
}

/**
 * Scroll to element
 *
 * @param element
 * @param mainObj
 */
function scrollBodyToElement(element, mainObj) {
    if (mainObj.querySelector(element)) {
        let elementPosition = mainObj.querySelector(element).offsetTop;
        let currentPosition = document.documentElement.scrollTop || document.body.scrollTop;

        let html = document.querySelector('html');
        let body = document.querySelector('body');
        animate(
            animateEaseInOut,
            function (progress) {
                let position = currentPosition + (elementPosition - currentPosition) * progress;
                html.scrollTop = body.scrollTop = position;
            },
            700
        );
    }
}

/**
 * Animate base function
 *
 * @param timing
 * @param draw
 * @param duration
 */
function animate(timing, draw, duration) {
    let start = performance.now();

    requestAnimationFrame(function animate(time) {
        let timeFraction = (time - start) / duration; // timeFraction goes from 0 to 1
        if (timeFraction > 1) timeFraction = 1;

        // calculate the current animation state
        let progress = timing(timeFraction);

        draw(progress); // draw it

        if (timeFraction < 1) {
            requestAnimationFrame(animate);
        }
    });
}

/**
 * Animate timing function (effect)
 *
 * @param timeFraction
 * @returns {number}
 */
function animateEaseInOut(timeFraction) {
    return 0.5 * (Math.sin((timeFraction - 0.5) * Math.PI) + 1);
}
